import React, { useState } from 'react'
import styled from '@emotion/styled'
import { useMutation } from '@apollo/react-hooks'
import { SettingsPageLayout } from '../../layout'
import { Button, ErrorModal } from '@labsavvyapp/ui-components'
import { CreateCustomerPortalSession } from '../../../../graphql/ecommerce/mutations'
import { SETTINGS } from '../../../../config/routes'
import style from './BillingSettingsPageView.module.css'

const ComponentLayout = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin: 15px;
`

export const BillingSettingsPageView: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [showErrorModal, setShowErrorModal] = useState(false)
    const [errorMessage, setErrorMessage] = useState<string | null>(null)

    const [createCustomerPortalSession] = useMutation(CreateCustomerPortalSession)

    const handleOpenStripeBillingPortal = async () => {
        setIsLoading(true)
        try {
            const returnUrl = `${window.location.origin}${SETTINGS.billingClose}`
            const { data } = await createCustomerPortalSession({
                variables: { returnUrl },
            })

            const portalUrl = data?.ecommerce_createCustomerPortalSession
            if (portalUrl) {
                // Use 85% of current window size
                const width = Math.round(window.innerWidth * 0.85)
                const height = Math.round(window.innerHeight * 0.85)
                const left = Math.round((window.screen.width - width) / 2)
                const top = Math.round((window.screen.height - height) / 2)
                const windowFeatures = `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=yes,status=no,scrollbars=yes,resizable=yes`
                window.open(portalUrl, 'StripeBillingPortal', windowFeatures)
            } else {
                throw new Error('Failed to get portal URL')
            }
        } catch (error: any) {
            setErrorMessage(error?.message || 'Failed to open Stripe Billing Portal')
            setShowErrorModal(true)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <SettingsPageLayout>
            <ComponentLayout>
                <div className={style.contentContainer}>
                    <h3 className={style.sectionTitle}>Manage Billing</h3>

                    <p className={style.description}>
                        This billing portal applies <strong>only to Client Bill accounts</strong> and does <strong>not</strong> apply to patient billing or patient payment responsibilities. <br /><br />
                        By selecting <strong>"Open Stripe Billing Portal"</strong>, you acknowledge and agree to LabSavvy's{' '}
                        <a href="https://www.labsavvy.com/terms-of-service" target="_blank" rel="noopener noreferrer">
                            <strong>Terms of Service</strong>
                        </a>
                        ,{' '}
                        <a href="https://www.labsavvy.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                            <strong>Privacy Policy</strong>
                        </a>
                        , and authorize LabSavvy to use your stored billing information for future client-related transactions. A secure Stripe Billing Portal window will open where you can update payment methods and manage your client account billing settings.
                    </p>
                    <div className={style.buttonContainer}>
                        <Button onClick={handleOpenStripeBillingPortal} disabled={isLoading}>
                            {isLoading ? 'Opening...' : 'Open Stripe Billing Portal'}
                        </Button>
                    </div>
                </div>
            </ComponentLayout>
            <ErrorModal message={errorMessage} onCloseClick={() => setShowErrorModal(false)} open={showErrorModal} />
        </SettingsPageLayout>
    )
}

